import { render, staticRenderFns } from "./GenerationHistoryDesignCardActions.vue?vue&type=template&id=66c642b7"
import script from "./GenerationHistoryDesignCardActions.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryDesignCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports